/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
//import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'
import shortid from 'shortid'



@observer
export default class DetailDataEntry extends React.Component {

    _divid = shortid.generate()
    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(()=>{this._calcwidths('#'+this._divid)});},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(did){
       // console.log('calcwidth',did)

        Utils.normalizeAddonWidths(did)



    }

    render (){
        const {baseDataStore} = this.props;
        const self = this;
        var z = 200;
        return <div id={self._divid} className="well">
            <h4>Details</h4>
            <hr/>

            {baseDataStore.detailEntries.map(entry => {
                z--;
                var styles = {zIndex : z};
                    if (entry instanceof InputModel) {
                        return( <div className="form-group zup" key={entry.key} style={styles}>

                            <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                        </div>)
                    }else{
                        return (<div key={entry.key} className="form-group zup" style={styles}>
                            <div className="input-group" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                            <div className="input-group-btn ">
                                <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                            </div>
                            </div>
                        </div>)
                    }

                }
            ) }
            <div className="form-group zup" key={baseDataStore.randschalung.key} >

                <InputComponent inputModel={baseDataStore.randschalung} inputClasses={['size-input-height']}/>
            </div>

        </div>;
    }

}

DetailDataEntry.propTypes = {
    baseDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/DetailDataEntry.js